import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-select-purchase-content-daily-dialog',
  templateUrl: './manual-select-purchase-content-daily-dialog.component.html',
  styleUrls: ['./manual-select-purchase-content-daily-dialog.component.css'],
  standalone: false,
})
export class ManualSelectPurchaseContentDailyDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
